import React, {Component} from 'react';
import { downloadBallots, isAfterDate, isBeforeDate, loadMyBallots, AuthenticatedUser, stopTimer } from "../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from './tournamentPageTemplate'
import PageCloser from '../../common/pageCloser'
import { Button} from 'reactstrap';
import download from 'downloadjs';

class TournamentCompetitorBallots extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.getTdProps = this.getTdProps.bind(this);
        this.onDownloadBallotClicked = this.onDownloadBallotClicked.bind(this);


        this.state = {
            loading: true,
            open: false,
            user: user,
            tData: {},
            pid: params.pid,
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            loadMyBallots(this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({tData: d2.tournamentPage, ballots: d2.ballots, loading: false});                    

                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    getTdProps(state, rowInfo, column) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: () => { 
                    const roomId = rowInfo.original.roomId;
                    const judgeId = rowInfo.original.judgeUserId;
                    this.props.history.push(`/tournament/ballot/room/judge/competitor/${this.state.tData._id}/${roomId}/${judgeId}/${this.state.user._id}`)                    
                },
                onMouseOver: (e) => {
                    this.setState({
                        selected: rowInfo.index
                    })
                },
                style: {
                    background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                    //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                }
            }
        } else { return {} }
    }

    onDownloadBallotClicked() {
        const {tData, user} = this.state;

        downloadBallots(tData._id, user._id).then(async d3 => {
            const blob = await d3.blob();
            download(blob, `${tData.title}_certs_ballots.zip`);
        });           
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user, ballots } = this.state;
            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Ballot List - ${user.displayname}`} title3=""
                bcTitle="Ballot List" bcParents={[{name: tData.title, url: `/pages/tournament/${tData._id}`}]} 
            >              
                <div className="container-fluid"> 
                {(isAfterDate(new Date(), new Date(tData.endDate))) &&
                <>
                    <div className="row">
                        <div className="col-sm-12">
                            <Button style={{margin: "4px"}} className="btn btn-solid pull-right" onClick={this.onDownloadBallotClicked} >Download Files</Button>
                            <p className="pull-right">Click to download PDF's of all your ballots and certifcations&nbsp;&nbsp;</p>                                     
                        </div>
                    </div>                           
                    <div className="row">
                        <div className="col-sm-12">
                            <ReactTable
                                filterable
                                data={ballots}
                                columns={[{
                                    Header: 'Submitted?',
                                    accessor: 'isSubmitted',
                                    style: { textAlign: 'center'},
                                    maxWidth: 100,                                   
                                    Cell: (row) => {
                                        return (
                                           <input
                                               type='checkbox'
                                               id={'iss'+row.original.ballotId}
                                               checked={row.original.isSubmitted}
                                               style={{zoom: "1.2", width: "20px", height: "20px"}}
                                           />                                          
                                        )}
                                },{
                                    Header: 'Round',
                                    accessor: 'round',
                                },{
                                    Header: 'Event',
                                    accessor: 'event',
                                },{
                                    Header: 'Room',
                                    accessor: 'room',
                                },{
                                    Header: 'Judge',
                                    accessor: 'judge',
                                }]}                                        
                                defaultPageSize={32}
                                showPagination={true}  
                                getTdProps={this.getTdProps}                                                                                                     
                            />
                        </div>
                    </div>  
                    </>
                    }
                    {isBeforeDate(new Date(), new Date(tData.endDate)) &&
                    <PageCloser 
                        header="Ballots are not available until tournament closes."
                        message={
                            <>
                            <p>Check back soon ...</p>
                            </>
                            }
                    />
                    }                    
                </div>
                          
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentCompetitorBallots;